import React from 'react';
import classNames from 'classnames';
import { Theme } from '@app/theme';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<string, {}, Theme>((theme: Theme) => ({
  title: {
    ...theme.fonts.h3,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.marginBase * 2,
  },
  line: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.marginBase,
  },
  '@keyframes spin': {
    from: {
      transform: 'rotate(0deg)',
    },
    to: {
      transform: 'rotate(360deg)',
    },
  },

  success: {
    color: theme.colors.greenAccessible,
  },
  failed: {
    color: theme.colors.redAccessible,
  },
  loading: {
    color: theme.colors.blueAccessible,
  },
  iconRound: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    fontSize: theme.iconSize.small,
    fontWeight: 'bold',

    width: theme.iconSize.regular,
    height: theme.iconSize.regular,
    borderRadius: '50%',
    color: theme.colors.white,
  },
  iconSuccess: {
    backgroundColor: theme.colors.greenAccessible,
  },
  iconFailure: {
    backgroundColor: theme.colors.redAccessible,
  },
  iconLoading: {
    animation: '$spin 1s linear infinite',
  },
}));

interface Props {
  result?: boolean;
  loading?: boolean;
  text: string;

  children?: React.ReactNode;
}

export const CheckResultLine = ({ text, result, loading, children }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  if (loading) {
    return (
      <li className={classes.container}>
        <div className={classNames(classes.line, classes.loading)}>
          <div className={classNames(classes.iconLoading)}>
            <i className={'ri-loader-4-line'} />
          </div>
          <div className={classes.text}>{t(text)}</div>
        </div>
        {children}
      </li>
    );
  }

  if (result) {
    return (
      <li className={classes.container}>
        <div className={classNames(classes.line, classes.success)}>
          <div className={classNames(classes.iconRound, classes.iconSuccess)}>
            <i className={'ri-check-line'} />
          </div>
          <div className={classes.text}>{t(text)}</div>
        </div>
        {children}
      </li>
    );
  }
  return (
    <li className={classes.container}>
      <div className={classNames(classes.line, classes.failed)}>
        <div className={classNames(classes.iconRound, classes.iconFailure)}>
          <i className={'ri-close-line'} />
        </div>
        <div className={classes.text}>{t(text)}</div>
      </div>
      {children}
    </li>
  );
};
